import { type FC, type PropsWithChildren } from 'react'
import { useZocksQuota } from '../../components/ScopedBlock/hooks'
import { DELTA_TRIAL_FEATURES } from '../Plan/DeltaTrial/DeltaTrialFeatures'
import { Upsell } from '../Plan/DeltaTrial/Upsell/Upsell'

export const SchedulingQuotaGate: FC<PropsWithChildren> = ({ children }) => {
  const { hasQuota, isFetching } = useZocksQuota({ refetchQuota: false, pollingInterval: 0 })
  if (isFetching) {
    return null
  }
  return hasQuota('scheduling.enabled.value') ? <>{children}</> : <Upsell feature={DELTA_TRIAL_FEATURES['scheduling']} />
}
